import type { ComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { AppBadgeColor } from '@shared/ui/badges'

import { useListsStore } from '@shared/model'

/** Status → badge tone. Labels come from `lists.promocode.status`. */
export const PROMOCODE_STATUS_COLORS: Record<string, AppBadgeColor> = {
  ACTIVE: 'emerald',
  DISABLED: 'slate',
}

interface PromocodeOptionsReturn {
  statusMap: ComputedRef<Record<string, string>>
  statusOptions: ComputedRef<AppSelectOption[]>
  getStatusLabel: (status: string) => string
}

export const usePromocodeOptions = (): PromocodeOptionsReturn => {
  const listsStore = useListsStore()

  const statusMap = computed<Record<string, string>>(() => listsStore.getLists?.promocode?.status ?? {})

  const statusOptions = computed<AppSelectOption[]>(() =>
    Object.entries(statusMap.value).map(([value, text]) => ({ value, text })))

  const getStatusLabel = (status: string): string => statusMap.value[status] ?? status

  return { statusMap, statusOptions, getStatusLabel }
}

export const toDiscountOptions = (discounts: string[]): AppSelectOption<number>[] =>
  discounts.map(discount => ({ value: Number(discount), text: `${discount}%` }))
